
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/learning/learning-support",
      function () {
        return require("private-next-pages/learning/learning-support.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/learning/learning-support"])
      });
    }
  